import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let human_user = new BaseTableModule('/ws/human_user/');

const state = {
    ...human_user.state,
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['employee_number'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
    columns: [
        {text: '', value: 'edit', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Active', value: 'active', sortable: true, filterable: true, divider: true, brief: false,},
        {text: 'user', value: 'user', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'First name', value: 'first_name', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Last name', value: 'last_name', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'employee number', value: 'employee_number', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Floor', value: 'floor', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Visible', value: 'visible', sortable: true, filterable: true, divider: true, brief: false,},
        {text: 'Pin code', value: 'pin_code', sortable: true, filterable: true, divider: true, brief: false,},
        ]

};
const getters = {
    ...human_user.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
    getBriefColumns(state) {
        return state.columns.filter(row => row.brief === true)
    },
};
const actions = {
    ...human_user.actions,
};
const mutations = {
    ...human_user.mutations,
};

export default {
    modules: {
        HumanUser: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}